
import React from "react";
import { useAdminReports } from "@/hooks/useAdminReports";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AdminContent } from "@/components/admin/AdminContent";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, Tag } from "lucide-react";

const AdminDashboard: React.FC = () => {
  const {
    reports,
    isLoading,
    currentPage,
    totalPages,
    handlePageChange,
    handleReportUpdate,
    search,
    setSearch,
    onSearch,
    showOtherSubjectsOnly,
    setShowOtherSubjectsOnly,
    sortField,
    sortDirection,
    handleSort,
    statusFilter,
    setStatusFilter,
    learningStatusFilter,
    setLearningStatusFilter,
    submittedOnTimeFilter,
    setSubmittedOnTimeFilter,
    hoursDeductedFilter,
    setHoursDeductedFilter,
    teachingDateFrom,
    setTeachingDateFrom,
    teachingDateTo,
    setTeachingDateTo,
    resetFilters,
    hasActiveFilters,
  } = useAdminReports();

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <div className="container mx-auto px-4 py-8">
            <h1 className="text-2xl font-bold mb-6">รายงานพัฒนาการนักเรียน</h1>
            
            <Alert className="mb-4">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>
                คุณสามารถค้นหา และกรองรายงานได้ นอกจากนี้ยังสามารถกรองเพื่อดูเฉพาะรายงานที่มีหัวข้ออื่นๆ
                <span className="font-medium ml-1">
                  โดยหัวข้อที่เป็น "หัวข้ออื่นๆ" จะมี <Tag className="inline h-3 w-3 text-amber-600" /> แท็กกำกับไว้
                </span>
              </AlertDescription>
            </Alert>
            
            <AdminContent
              isLoading={isLoading}
              reports={reports}
              currentPage={currentPage}
              totalPages={totalPages}
              onReportUpdate={handleReportUpdate}
              onPageChange={handlePageChange}
              search={search}
              setSearch={setSearch}
              onSearch={onSearch}
              showOtherSubjectsOnly={showOtherSubjectsOnly}
              setShowOtherSubjectsOnly={setShowOtherSubjectsOnly}
              sortField={sortField}
              sortDirection={sortDirection}
              onSort={handleSort}
              statusFilter={statusFilter}
              setStatusFilter={setStatusFilter}
              learningStatusFilter={learningStatusFilter}
              setLearningStatusFilter={setLearningStatusFilter}
              submittedOnTimeFilter={submittedOnTimeFilter}
              setSubmittedOnTimeFilter={setSubmittedOnTimeFilter}
              hoursDeductedFilter={hoursDeductedFilter}
              setHoursDeductedFilter={setHoursDeductedFilter}
              teachingDateFrom={teachingDateFrom}
              setTeachingDateFrom={setTeachingDateFrom}
              teachingDateTo={teachingDateTo}
              setTeachingDateTo={setTeachingDateTo}
              resetFilters={resetFilters}
              hasActiveFilters={hasActiveFilters}
            />
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default AdminDashboard;
